export enum Location {
  Localhost = 'localhost',
  Preview = 'preview.lumatrak.com',
  Pulse = 'pulse.lumatrak.com',
  Beta = 'beta.lumatrak.com',
  Status = 'status.lumatrak.com'
}
